export default __webpack_public_path__ + "static/media/serojaCycloneChi.d5441c72.jpg";